import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    input: {
      width: '100%',
      margin: theme.spacing(1.5, 0),
      padding: theme.spacing(0, 0),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'right',
      width: '100%',
      marginTop: theme.spacing(4),
      '& > button': {
        alignSelf: 'flex-end',
        width: 'auto',
        margin: theme.spacing(0, 0),
      },
    },
  }),
)
